module.exports = __webpack_public_path__ + "img/list3.05488279.jpg";